<template>
  <b-card-code>
    <b-modal
      id="changePrivateMessage"
      title="Státusz állítása"
      hide-footer
    >
      <b-row class="my-1 pl-1 pr-1">
        <b-col lg="12">
          <b-form-group
            label="Megjegyzés"
            label-for="title"
          >
            <b-form-input
              id="title"
              v-model="title"
              class="w-100"
            />
          </b-form-group>
        </b-col>
        <b-col lg="12">
          <b-form-group
            label="Kire vonatkozik"
            label-for="target_name"
          >
            <b-form-input
              id="target_name"
              v-model="target_name"
              class="w-100"
            />
          </b-form-group>
        </b-col>
        <b-col
          lg="12"
          class="justify-content-end d-flex my-2"
        >
          <b-button
            size="sm"
            variant="danger"
            @click="$bvModal.hide('changePrivateMessage')"
          >
            Mégsem
          </b-button>
          <b-button
            class="ml-1"
            size="sm"
            variant="success"
            @click="updatePrivateMessage()"
          >
            Rögzítés
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
    <div class="row justify-space-between mb-2 align-items-center">
      <div class="col-lg-2">
        <h4>Eldöntendő szabadságok</h4>
      </div>
      <div class="col-lg-10 text-right row justify-content-end">
        <button
          class="btn btn-primary col-lg-2 col-12"
          @click="$router.push('/freedays/list')"
        >
          Összes nézet
        </button>
      </div>
    </div>
    <!-- table -->
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
      :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >

        <div
          v-if="props.column.field === 'leader_accepted'"
          class="text-center"
          :title="props.row.leader_name"
        >
          <feather-icon
            v-if="props.row.leader_accepted == 1"
            icon="CheckCircleIcon"
            size="26"
            class="text-success"
          />
          <feather-icon
            v-else-if="props.row.leader_accepted == 2"
            icon="MinusCircleIcon"
            size="26"
            class="text-danger"
          />
          <feather-icon
            v-else
            icon="AlertCircleIcon"
            size="26"
            class="text-warning"
          />
        </div>

        <div v-else-if="props.column.field === 'archive'">
          <span v-if="props.row.archive">Arcivált</span>
          <span v-else>Aktív</span>
        </div>

        <div
          v-else-if="props.column.field === 'foreman_accepted'"
          class="text-center"
          :title="props.row.foreman_name"
        >
          <feather-icon
            v-if="props.row.foreman_accepted == 1"
            icon="CheckCircleIcon"
            size="26"
            class="text-success"
          />
          <feather-icon
            v-else-if="props.row.foreman_accepted == 2"
            icon="MinusCircleIcon"
            size="26"
            class="text-danger"
          />
          <feather-icon
            v-else
            icon="AlertCircleIcon"
            size="26"
            class="text-warning"
          />
        </div>

        <div
          v-else-if="props.column.field === 'foreman_name'"
        >
          {{ props.row.foreman_name }}
        </div>

        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
              <b-dropdown-item
                v-show="checkRole('foreman_freeday') && props.row.foreman_accepted != 1"
                @click="changeForeman(props.row.id)"
              >
                <feather-icon
                  icon="CheckCircleIcon"
                  class="mr-50"
                />
                <span>Elfogadás</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-show="checkRole('foreman_freeday') && props.row.foreman_accepted != 2"
                @click="changeForemanDisable(props.row.id)"
              >
                <feather-icon
                  icon="XIcon"
                  class="mr-50"
                />
                <span>Elutasítás</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-show="checkRole('leader_freeday') && props.row.leader_accepted != 1"
                @click="changeLeader(props.row.id)"
              >
                <feather-icon
                  icon="CheckCircleIcon"
                  class="mr-50"
                />
                <span>Elfogadás</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-show="checkRole('leader_freeday') && props.row.leader_accepted != 2"
                @click="changeLeaderDisable(props.row.id)"
              >
                <feather-icon
                  icon="XIcon"
                  class="mr-50"
                />
                <span>Elutasítás</span>
              </b-dropdown-item>
              <b-dropdown-item @click="edit(props.row.id)">
                <feather-icon
                  icon="Edit2Icon"
                  class="mr-50"
                />
                <span>Szerkesztés</span>
              </b-dropdown-item>
              <b-dropdown-item @click="archive(props.row.id)">
                <feather-icon
                  icon="BoxIcon"
                  class="mr-50"
                />
                <span>Archiv státusz változtatása</span>
              </b-dropdown-item>
              <!--<b-dropdown-item @click="deleteComment(props.row.id)">
                <feather-icon
                  icon="XCircleIcon"
                  class="mr-50"
                />
                <span>Törlés</span>
              </b-dropdown-item>-->
            </b-dropdown>
          </span>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">
              Mutasd 1-től
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['25','50','100']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap ">-ig a {{ props.total }} elemet </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
    <b-modal
      id="free_day_request"
      ref="free_day_request"
      hide-footer
      title="Szabadság igény rögzítése"
    >
      <b-row>
        <b-col md="12">
          <b-form-group
            label="Szabadság típusa"
          >
            <b-form-select
              v-model="free_day_request.type"
              :options="free_day_request_types_create"
              label="Szabadság típusa"
            />
          </b-form-group>

          <b-form-group
            label="Alkalmazott"
          >
            <b-form-select
              v-model="free_day_request.employee_id"
              :options="employees_create"
              label="Alkalmazott"
              text-field="name"
              value-field="id"
            />
            <!-- Vacation Info Bar -->
            <div
              v-if="free_day_request.employee_id && free_day_request.employee_id !== '%' && free_day_request.type === 'Szabadság'"
              v-b-tooltip.hover
              class="mt-2 p-2 rounded"
              :class="getVacationInfoBarClass()"
              :title="getVacationTooltipInfo()"
            >
              <small>
                <feather-icon
                  :icon="getVacationInfoIcon()"
                  size="14"
                  class="mr-1"
                />
                {{ getVacationInfoText() }}
              </small>
            </div>
          </b-form-group>

          <b-form-group
            label="Építővezető"
          >
            <b-form-select
              v-model="free_day_request.foreman_id"
              :options="foreman_list"
              label="Építővezető"
              text-field="name"
              value-field="id"
            />
          </b-form-group>

          <b-form-group
            label="Szabadság kezdete"
          >
            <b-form-input
              v-model="free_day_request.start_date"
              type="date"
              max="9999-12-31"
              label="Szabadság kezdete"
            />
          </b-form-group>

          <b-form-group
            label="Szabadság vége"
          >
            <b-form-input
              v-model="free_day_request.end_date"
              type="date"
              max="9999-12-31"
              label="Szabadság vége"
            />
          </b-form-group>

          <b-form-group
            label="Megjegyzés"
          >
            <b-form-input
              v-model="free_day_request.comment"
              type="textarea"
              label="Megjegyzés"
            />
          </b-form-group>
          <p class="text-right mt-2">
            <button
              class="btn btn-primary"
              @click="createFreeDay()"
            >
              Rögzítés
            </button>
          </p>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      id="update_free_day_request"
      ref="update_free_day_request"
      hide-footer
      title="Szabadság igény szerkesztése"
    >
      <b-row>
        <b-col md="12">
          <b-form-group
            label="Szabadság típusa"
          >
            <b-form-select
              v-model="update_free_day_request.type"
              :options="free_day_request_types_create"
              label="Szabadság típusa"
            />
          </b-form-group>

          <b-form-group
            label="Alkalmazott"
          >
            <b-form-select
              v-model="update_free_day_request.employee_id"
              :options="employees_create"
              label="Alkalmazott"
              text-field="name"
              value-field="id"
            />
            <!-- Vacation Info Bar -->
            <div
              v-if="update_free_day_request.employee_id && update_free_day_request.employee_id !== '%' && update_free_day_request.type === 'Szabadság'"
              v-b-tooltip.hover
              class="mt-2 p-2 rounded"
              :class="getVacationInfoBarClassUpdate()"
              :title="getVacationTooltipInfoUpdate()"
            >
              <small>
                <feather-icon
                  :icon="getVacationInfoIconUpdate()"
                  size="14"
                  class="mr-1"
                />
                {{ getVacationInfoTextUpdate() }}
              </small>
            </div>
          </b-form-group>

          <b-form-group
            label="Építővezető"
          >
            <b-form-select
              v-model="update_free_day_request.foreman_id"
              :options="foreman_list"
              label="Építővezető"
              text-field="name"
              value-field="id"
            />
          </b-form-group>

          <b-form-group
            label="Szabadság kezdete"
          >
            <b-form-input
              v-model="update_free_day_request.start_date"
              type="date"
              max="9999-12-31"
              label="Szabadság kezdete"
            />
          </b-form-group>

          <b-form-group
            label="Szabadság vége"
          >
            <b-form-input
              v-model="update_free_day_request.end_date"
              type="date"
              max="9999-12-31"
              label="Szabadság vége"
            />
          </b-form-group>

          <b-form-group
            label="Megjegyzés"
          >
            <b-form-input
              v-model="update_free_day_request.comment"
              type="textarea"
              label="Megjegyzés"
            />
          </b-form-group>
          <p class="text-right mt-2">
            <button
              class="btn btn-primary"
              @click="updateFreeDay()"
            >
              Frissítés
            </button>
          </p>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      id="filter_modal"
      ref="filter_modal"
      hide-footer
      title="Szűrés"
    >
      <b-form-group
        label="Kezdő dátum"
      >
        <b-form-input
          v-model="filter.start_date"
          type="date"
          max="9999-12-31"
          label="Kezdő dátum"
        />
      </b-form-group>
      <b-form-group
        label="Vég dátum"
      >
        <b-form-input
          v-model="filter.end_date"
          type="date"
          max="9999-12-31"
          label="Vég dátum"
        />
      </b-form-group>
      <b-form-group
        label="Alkalmazott"
      >
        <b-form-select
          v-model="filter.employee_id"
          :options="employees"
          label="Alkalmazott"
          text-field="name"
          value-field="id"
        />
      </b-form-group>
      <b-form-group
        label="Szabadság típusa"
      >
        <b-form-select
          v-model="filter.type"
          :options="free_day_request_types"
          label="Szabadság típusa"
        />
      </b-form-group>
      <b-form-group
        label="Építésvezető"
      >
        <b-form-select
          v-model="filter.foreman_id"
          :options="foreman_list"
          label="Építésvezető"
          text-field="name"
          value-field="id"
        />
      </b-form-group>
      <b-form-group
        label="Komment szűrés"
      >
        <b-form-input
          v-model="filter.comment"
          type="text"
          placeholder="Írj be szöveget a kommentekben való kereséshez..."
          label="Komment szűrés"
        />
      </b-form-group>
      <b-form-group
        label="Archivált"
      >
        <b-form-select
          v-model="filter.archive"
          :options="archiveStatus"
          label="Archivált"
        />
      </b-form-group>
      <p class="text-center">
        <button
          class="btn btn-primary mt-1"
          @click="runFilter()"
        >
          Szűrés
        </button>
      </p>
    </b-modal>
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BBadge, BPagination, BFormSelect, BDropdown, BDropdownItem, BFormInput, BFormGroup, BButton,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from 'axios'

export default {
  components: {
    BCardCode,
    VueGoodTable,
    BBadge,
    BPagination,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BFormInput,
    BFormGroup,
    BButton,
  },
  data() {
    return {
      pageLength: 25,
      dir: false,
      columns: [
        {
          label: 'Vezető',
          field: 'leader_accepted',
          filterOptions: {
            enabled: false,
            placeholder: 'Státusz',
          },
        },
        {
          label: 'Építés vezető',
          field: 'foreman_accepted',
          filterOptions: {
            enabled: false,
            placeholder: 'Keresés megjegyzésben',
          },
        },
        {
          label: 'Alkalmazott',
          field: 'employee_name',
          filterOptions: {
            enabled: true,
            placeholder: 'Keresés névre',
          },
        },
        {
          label: 'Szabadnap kezdete',
          field: 'start_date',
          filterOptions: {
            enabled: false,
            placeholder: 'Keresés névre',
          },
        },
        {
          label: 'Szadnap vége',
          field: 'end_date',
          filterOptions: {
            enabled: false,
            placeholder: 'Keresés névre',
          },
        },
        {
          label: 'Kezdés időpontja',
          field: 'timeStart',
          filterOptions: {
            enabled: false,
            placeholder: 'Keresés névre',
          },
        },
        {
          label: 'Végzés időpontja',
          field: 'timeEnd',
          filterOptions: {
            enabled: false,
            placeholder: 'Keresés névre',
          },
        },
        {
          label: 'Típus',
          field: 'type',
          filterOptions: {
            enabled: true,
            placeholder: 'Típusa',
          },
        },
        {
          label: 'Komment',
          field: 'comment',
          filterOptions: {
            enabled: true,
            placeholder: 'Keresés szövegben',
          },
        },
        {
          label: 'Építés vezető',
          field: 'foreman_name',
          filterOptions: {
            enabled: false,
            placeholder: 'Keresés szövegben',
          },
        },
        {
          label: '',
          field: 'action',
        },
      ],
      archiveStatus: [
        {
          value: '%',
          text: 'Mind',
        },
        {
          value: false,
          text: 'Nem',
        },
        {
          value: true,
          text: 'Igen',
        },
      ],
      employees: [],
      employees_create: [],
      rows: [],
      searchTerm: '',
      title: '',
      target_name: '',
      selected_id: '',
      filter: {
        start_date: '',
        end_date: '',
        employee_id: '%',
        type: '%',
        archive: '%',
        foreman_id: '%',
        comment: '',
      },
      foreman_list: [],
      free_day_request: {
        type: '',
        foreman_id: '',
        employee_id: '',
        start_date: '',
        end_date: '',
        comment: '',
      },
      update_free_day_request: {
        type: '',
        foreman_id: '',
        employee_id: '',
        start_date: '',
        end_date: '',
        comment: '',
      },
      free_day_request_types: [
        {
          text: 'Összes',
          value: '%',
        },
        {
          text: 'Szabadság',
          value: 'Szabadság',
        },
        {
          text: 'Táppénz',
          value: 'Táppénz',
        },
        {
          text: 'Szabadnap',
          value: 'Szabadnap',
        },
        {
          text: 'Igazolatlan',
          value: 'Igazolatlan',
        },
        {
          text: 'Fizetetlen',
          value: 'Fizetetlen',
        },
        {
          text: 'Táppénz (OEP)',
          value: 'Táppénz (OEP)',
        },
        {
          text: 'Apasági szabadság',
          value: 'Apasági szabadság',
        },
      ],
      free_day_request_types_create: [
        {
          text: 'Szabadság',
          value: 'Szabadság',
        },
        {
          text: 'Táppénz',
          value: 'Táppénz',
        },
        {
          text: 'Szabadnap',
          value: 'Szabadnap',
        },
        {
          text: 'Igazolatlan',
          value: 'Igazolatlan',
        },
        {
          text: 'Fizetetlen',
          value: 'Fizetetlen',
        },
        {
          text: 'Táppénz (OEP)',
          value: 'Táppénz (OEP)',
        },
        {
          text: 'Apasági szabadság',
          value: 'Apasági szabadság',
        },
      ],
    }
  },
  computed: {
    statusVariant() {
      const statusColor = {
        Folyamatban: 'light-info',
        Késésben: 'light-warning',
        Lejárt: 'light-danger',
        Kész: 'light-success',
      }

      return status => statusColor[status]
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  mounted() {
    this.runFilter()
    this.getEmployees()
    this.getForemanList()
  },
  methods: {
    runFilter() {
      // For leader view, we can use the same filter API but with additional constraints
      axios({
        method: 'post',
        url: 'freeday/filter/leader',
        data: this.filter,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(res => {
        this.rows = res.data.data || res.data
        if (this.$refs.filter_modal) {
          this.$refs.filter_modal.hide()
        }
      }).catch(() => {
        // Fallback to original endpoint if filter endpoint doesn't exist
        axios({
          method: 'get',
          url: 'freeday/list/own/boss',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }).then(res => {
          this.rows = res.data
        })
      })
    },
    openFilter() {
      this.$refs.filter_modal.show()
    },
    changeForeman(id) {
      axios({
        method: 'get',
        url: `freeday/change-foreman-status/${id}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Státusz sikeresen állítva',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        this.runFilter()
      })
    },
    changeForemanDisable(id) {
      axios({
        method: 'get',
        url: `freeday/change-foreman-status-disable/${id}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Státusz sikeresen állítva',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        this.runFilter()
      })
    },
    edit(id) {
      this.selected_id = id
      this.update_free_day_request = this.rows.find(item => item.id === id)
      this.$refs.update_free_day_request.show()
    },
    changeLeader(id) {
      axios({
        method: 'get',
        url: `freeday/change-leader-status/${id}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Státusz sikeresen állítva',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        this.runFilter()
      })
    },
    changeLeaderDisable(id) {
      axios({
        method: 'get',
        url: `freeday/change-leader-status-disable/${id}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Státusz sikeresen állítva',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        this.runFilter()
      })
    },
    getArchiveNameById(id) {
      const archive = this.archiveStatus.find(item => item.value === id)
      return archive.text
    },
    getEmployeeNameById(id) {
      const employee = this.employees.find(item => item.id === id)
      return employee.name
    },
    updateFreeDay() {
      axios({
        method: 'put',
        url: `freeday/update/${this.selected_id}`,
        data: this.update_free_day_request,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Szabadnap frissítve lett',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        this.update_free_day_request.type = ''
        this.update_free_day_request.foreman_id = ''
        this.update_free_day_request.employee_id = ''
        this.update_free_day_request.start_date = ''
        this.update_free_day_request.end_date = ''
        this.update_free_day_request.comment = ''
        this.$refs.update_free_day_request.hide()
        this.runFilter()
      })
    },
    createFreeDay() {
      axios({
        method: 'post',
        url: 'freeday/create',
        data: this.free_day_request,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(res => {
        if (res.data && res.data.error) {
          return this.$toast({
            component: ToastificationContent,
            props: {
              title: res.data.error,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        }
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Szabadnap rögzítve lett',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        this.free_day_request.type = ''
        this.free_day_request.foreman_id = ''
        this.free_day_request.employee_id = ''
        this.free_day_request.start_date = ''
        this.free_day_request.end_date = ''
        this.free_day_request.comment = ''
        this.$refs.free_day_request.hide()
        this.runFilter()
      }).catch(err => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Minden mező kitöltése kötelező',
            icon: 'XIcon',
            variant: 'danger',
          },
        })
      })
    },
    checkRole(role) {
      return JSON.parse(localStorage.getItem('user')).role.includes(role)
    },
    openFreeDayRequest() {
      this.$refs.free_day_request.show()
    },
    getEmployees() {
      axios({
        method: 'get',
        url: 'employee/list/proportional_day_off',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(res => {
        // Store employees with original names but keep available_days data
        this.employees = [...res.data]
        this.employees_create = [...res.data]
        this.employees.push({
          id: '%',
          name: 'Minden alkalmazott',
        })
      })
    },
    archive(id) {
      axios({
        method: 'get',
        url: `freeday/archive/${id}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(res => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Státusz sikeresen állítva',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        this.runFilter()
      })
    },
    getFreeDays() {
      axios({
        method: 'get',
        url: 'freeday/list',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(res => {
        this.rows = res.data
      })
    },
    getForemanList() {
      axios({
        method: 'get',
        url: 'role/list/foreman_freeday',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(res => {
        this.foreman_list = [...res.data]
        this.foreman_list.unshift({
          id: '%',
          name: 'Minden építésvezető',
        })
      })
    },
    calculateWorkingDays(startDate, endDate) {
      if (!startDate || !endDate) return 0

      const start = new Date(startDate)
      const end = new Date(endDate)
      let workingDays = 0

      for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
        const dayOfWeek = d.getDay()
        // Skip weekends (Saturday = 6, Sunday = 0)
        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
          workingDays += 1
        }
      }

      return workingDays
    },
    getSelectedEmployeeVacationDays(employeeId) {
      if (!employeeId || employeeId === '%') return null
      const employee = this.employees_create.find(emp => emp.id === parseInt(employeeId, 10))
      return employee ? employee.available_days : null
    },
    getVacationDaysInfo() {
      if (!this.free_day_request.employee_id || this.free_day_request.employee_id === '%') {
        return 'Válassz alkalmazottat az arányos szabadság információk megtekintéséhez'
      }

      const availableDays = this.getSelectedEmployeeVacationDays(this.free_day_request.employee_id)
      const requestedDays = this.calculateWorkingDays(this.free_day_request.start_date, this.free_day_request.end_date)

      if (availableDays === null) return 'Alkalmazott adatok nem találhatók'

      let info = `Elérhető szabadság: ${availableDays} nap`
      if (requestedDays > 0) {
        info += `\nKért napok: ${requestedDays} nap`
        if (requestedDays > availableDays) {
          info += '\n⚠️ FIGYELEM: A kért napok száma meghaladja az elérhető szabadságot!'
        }
      }

      return info
    },
    getVacationDaysInfoUpdate() {
      if (!this.update_free_day_request.employee_id || this.update_free_day_request.employee_id === '%') {
        return 'Válassz alkalmazottat az arányos szabadság információk megtekintéséhez'
      }

      const availableDays = this.getSelectedEmployeeVacationDays(this.update_free_day_request.employee_id)
      const requestedDays = this.calculateWorkingDays(this.update_free_day_request.start_date, this.update_free_day_request.end_date)

      if (availableDays === null) return 'Alkalmazott adatok nem találhatók'

      let info = `Elérhető szabadság: ${availableDays} nap`
      if (requestedDays > 0) {
        info += `\nKért napok: ${requestedDays} nap`
        if (requestedDays > availableDays) {
          info += '\n⚠️ FIGYELEM: A kért napok száma meghaladja az elérhető szabadságot!'
        }
      }

      return info
    },
    getVacationInfoBarClass() {
      const availableDays = this.getSelectedEmployeeVacationDays(this.free_day_request.employee_id)
      const requestedDays = this.calculateWorkingDays(this.free_day_request.start_date, this.free_day_request.end_date)

      if (requestedDays > 0 && availableDays !== null && requestedDays > availableDays) {
        return 'bg-danger text-white'
      }
      return 'bg-primary text-white'
    },
    getVacationInfoIcon() {
      const availableDays = this.getSelectedEmployeeVacationDays(this.free_day_request.employee_id)
      const requestedDays = this.calculateWorkingDays(this.free_day_request.start_date, this.free_day_request.end_date)

      if (requestedDays > 0 && availableDays !== null && requestedDays > availableDays) {
        return 'AlertTriangleIcon'
      }
      return 'InfoIcon'
    },
    getVacationInfoText() {
      const selectedEmployee = this.employees_create.find(emp => emp.id === parseInt(this.free_day_request.employee_id, 10))
      if (!selectedEmployee) return 'Alkalmazott adatok betöltése...'

      const availableDays = selectedEmployee.available_days
      const requestedDays = this.calculateWorkingDays(this.free_day_request.start_date, this.free_day_request.end_date)

      if (requestedDays > 0 && requestedDays > availableDays) {
        return `${selectedEmployee.name}: ${availableDays} nap - NINCS ELÉG SZABADSÁG!`
      }
      return `${selectedEmployee.name}: ${availableDays} nap arányos szabadság`
    },
    getVacationTooltipInfo() {
      const selectedEmployee = this.employees_create.find(emp => emp.id === parseInt(this.free_day_request.employee_id, 10))
      if (!selectedEmployee) return 'Alkalmazott adatok betöltése...'

      const availableDays = selectedEmployee.available_days
      const requestedDays = this.calculateWorkingDays(this.free_day_request.start_date, this.free_day_request.end_date)

      let tooltip = `Elérhető szabadság: ${availableDays} nap`
      if (requestedDays > 0) {
        tooltip += `\nKért napok: ${requestedDays} nap`
        if (requestedDays > availableDays) {
          tooltip += `\nHiányzó napok: ${requestedDays - availableDays}`
        }
      }
      return tooltip
    },
    getVacationInfoBarClassUpdate() {
      const availableDays = this.getSelectedEmployeeVacationDays(this.update_free_day_request.employee_id)
      const requestedDays = this.calculateWorkingDays(this.update_free_day_request.start_date, this.update_free_day_request.end_date)

      if (requestedDays > 0 && availableDays !== null && requestedDays > availableDays) {
        return 'bg-danger text-white'
      }
      return 'bg-primary text-white'
    },
    getVacationInfoIconUpdate() {
      const availableDays = this.getSelectedEmployeeVacationDays(this.update_free_day_request.employee_id)
      const requestedDays = this.calculateWorkingDays(this.update_free_day_request.start_date, this.update_free_day_request.end_date)

      if (requestedDays > 0 && availableDays !== null && requestedDays > availableDays) {
        return 'AlertTriangleIcon'
      }
      return 'InfoIcon'
    },
    getVacationInfoTextUpdate() {
      const selectedEmployee = this.employees_create.find(emp => emp.id === parseInt(this.update_free_day_request.employee_id, 10))
      if (!selectedEmployee) return 'Alkalmazott adatok betöltése...'

      const availableDays = selectedEmployee.available_days
      const requestedDays = this.calculateWorkingDays(this.update_free_day_request.start_date, this.update_free_day_request.end_date)

      if (requestedDays > 0 && requestedDays > availableDays) {
        return `${selectedEmployee.name}: ${availableDays} nap - NINCS ELÉG SZABADSÁG!`
      }
      return `${selectedEmployee.name}: ${availableDays} nap arányos szabadság`
    },
    getVacationTooltipInfoUpdate() {
      const selectedEmployee = this.employees_create.find(emp => emp.id === parseInt(this.update_free_day_request.employee_id, 10))
      if (!selectedEmployee) return 'Alkalmazott adatok betöltése...'

      const availableDays = selectedEmployee.available_days
      const requestedDays = this.calculateWorkingDays(this.update_free_day_request.start_date, this.update_free_day_request.end_date)

      let tooltip = `Elérhető szabadság: ${availableDays} nap`
      if (requestedDays > 0) {
        tooltip += `\nKért napok: ${requestedDays} nap`
        if (requestedDays > availableDays) {
          tooltip += `\nHiányzó napok: ${requestedDays - availableDays}`
        }
      }
      return tooltip
    },
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';

.cursor-pointer {
  cursor: pointer;
}
</style>
